import { USER_ROLES } from "./constants";
import { isAPullOrPushClientLoggedIn } from "./utils/secure-xs/secureSS";
import { isAPullClientLoggedIn, isAPushClientLoggedIn } from "./utils/secure-xs/secureSS";

const {
  SUPER_USER,
  USER,
  POTENTIAL_USER,
  CLIENT_ADMIN,
  CLIENT_SUPPORT,
  CLIENT_FINANCE,
  CLIENT_COMMERCIAL_TEAM,
  CLIENT_DEV,
  CLIENT_EXTERNAL_DEV
} = USER_ROLES;
const rules = {
  [USER]: {
    static: [],
    homePage: "/home"
  },
  [SUPER_USER]: {
    static: [
      "dayrateConfig",
      "advancedARISearch",
      "quickPriceSearch",
      "searchApiRates",
      "dayRateCalendarLookup",
      "dayRateCalendar",
      "rateAvailabilityAudit",
      "propertyManagement",
      "policies",
      "hotelbedsMapping",
      "rooms",
      "reports",
      "admin-reports",
      "suOnlyControls",
      "validateReservations",
      "updateGuestInformation",
      "cacheLiveStatus",
      "usersCompaniesManagement",
      "cancelReservation",
      "rateplanManagement",
      "rateplansListManagement",
      "reportsFailed",
      "invoiceModule",
      "invoiceModuleSuperAdmin",
      "IntgARIMonitoringManagement",
      "auditARIDashboard",
      "clientManagement",
      "listClients",
      "addClient",
      "stratificationManagement"
    ],
    homePage: "/home"
  },
  [POTENTIAL_USER]: {
    static: ["dayrateConfig", "advancedARISearch", "quickPriceSearch"],
    homePage: "/home/advanced-ari-search"
  },
  [CLIENT_ADMIN]: {
    static: [
      "dayrateConfig",
      "advancedARISearch",
      "reports",
      "invoiceModule",
      "invoiceModuleClientAdmin",
      "clientManagement",
      "viewClientInfo"
    ],
    dynamic: {
      "reports:edit": ({ userId, postOwnerId }) => {
        if (!userId || !postOwnerId) return false;
        return userId === postOwnerId;
      },
      dayrateConfig: () => isAPullOrPushClientLoggedIn(),
      advancedARISearch: () => isAPullOrPushClientLoggedIn(),
      quickPriceSearch: () => isAPullClientLoggedIn(),
      dayRateCalendarLookup: () => isAPushClientLoggedIn()
    },
    homePage: "/home/reservation-report"
  },
  [CLIENT_FINANCE]: {
    static: [
      "reports",
      "invoiceModule",
      "invoiceModuleClientAdmin",
      "clientManagement",
      "viewClientInfo"
    ],
    dynamic: {
      "reports:edit": ({ userId, postOwnerId }) => {
        if (!userId || !postOwnerId) return false;
        return userId === postOwnerId;
      }
    },
    homePage: "/home/invoices/list"
  },
  [CLIENT_SUPPORT]: {
    static: ["reports", "dayrateConfig", "advancedARISearch"],
    dynamic: {
      dayrateConfig: () => isAPullOrPushClientLoggedIn(),
      advancedARISearch: () => isAPullOrPushClientLoggedIn(),
      quickPriceSearch: () => isAPullClientLoggedIn(),
      dayRateCalendarLookup: () => isAPushClientLoggedIn()
    },
    homePage: "/home/reservation-report"
  },
  [CLIENT_COMMERCIAL_TEAM]: {
    static: [
      "dayrateConfig",
      "advancedARISearch",
      "reports",
      "invoiceModule",
      "invoiceModuleClientAdmin",
      "clientManagement",
      "viewClientInfo"
    ],
    dynamic: {
      "reports:edit": ({ userId, postOwnerId }) => {
        if (!userId || !postOwnerId) return false;
        return userId === postOwnerId;
      },
      dayrateConfig: () => isAPullOrPushClientLoggedIn(),
      advancedARISearch: () => isAPullOrPushClientLoggedIn(),
      quickPriceSearch: () => isAPullClientLoggedIn(),
      dayRateCalendarLookup: () => isAPushClientLoggedIn()
    },
    homePage: "/home/reservation-report"
  },
  [CLIENT_DEV]: {},
  [CLIENT_EXTERNAL_DEV]: {}
};

export default rules;
